const NotificationType = {
    SUCCESS: 'success',
    ERROR: 'error'
};

module.exports = NotificationType